import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditAssignmentMutation,
  useGetSingleAssignmentQuery,
} from "../../../features/Assignments/assignmentsApi";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import Error from "../../ErrorMessage";
import AssignmentForm from "./AssignmentForm";

const initialState = {
  title: "",
  totalMark: 0,
};

export default function EditAssignmentForm() {
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const [formValues, setFormValues] = useState(initialState);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const { data: videos } = useGetVideosQuery();

  const {
    data: singleAssignment,
    isLoading,
    isSuccess: isGetSingleAssignmentSuccess,
    isError: isGetSingleAssignmentFailed,
  } = useGetSingleAssignmentQuery(+assignmentId);
  const [
    editAssignment,
    { isSuccess: isEditAssignmentSuccess, isError: isEditAssignmentError },
  ] = useEditAssignmentMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formValues.totalMark <= 0) {
      alert("Please enter a valid total mark!");
      return;
    }

    editAssignment({
      ...formValues,
      totalMark: +formValues.totalMark,
      video_id: selectedVideo.id,
      video_title: selectedVideo.title,
      id: +assignmentId,
    });
  };

  useEffect(() => {
    if (isGetSingleAssignmentSuccess) {
      const { title, totalMark, video_id } = singleAssignment;
      setFormValues({ title, totalMark });

      const selectedVideo = videos?.find((video) => video.id === video_id);
      setSelectedVideo(selectedVideo);
    }
  }, [isGetSingleAssignmentSuccess, singleAssignment, videos]);

  useEffect(() => {
    if (isEditAssignmentSuccess) {
      setFormValues(initialState);
      navigate(routes.admin.assignments, { replace: true });
    } else if (isEditAssignmentError) {
      alert("Failed to edit assignment!");
    }
  }, [isEditAssignmentError, isEditAssignmentSuccess, navigate]);

  if (isLoading) return <div>Loading assignment data...</div>;
  if (isGetSingleAssignmentFailed)
    return <Error error="Failed to load assignment data!" />;

  return (
    <AssignmentForm
      isForEdit={true}
      handleSubmit={handleSubmit}
      setSelectedVideo={setSelectedVideo}
      selectedVideo={selectedVideo}
      setFormValues={setFormValues}
      formValues={formValues}
      videos={videos}
    />
  );
}
